export default () => {
  $("#member-form").on("submit", function (e) {
    e.preventDefault();
    var name = $("#name").val();
    var type = $("#type").val();
    $.ajax({
      type: "post",
      url: myAjax.ajaxurl,
      data: {
        action: "get-data-member",
        company_name: name,
        company_type: type,
      },
      success: function (response) {
        $(".block-member__list").html(response);
      },
      complete: function () {
        //$('.data-check').hide();
      },
    });
  });
};
